/* eslint-disable no-param-reassign */
import axios from 'axios'
import { thunk, action, computed } from 'easy-peasy'

import getEnvironment from '../../utils/getEnvironment'

export default {
  server: {},
  showResults: false,
  stepQuiz: 0,
  questions: [],
  answers: [],
  score: '',
  coupon: '',
  percent: computed(
    state =>
      (100 / (state.questions.length + 1)) * (state.stepQuiz + 1),
  ),
  unlocked: computed(state => state.currentValue !== undefined),
  current: computed(state => state.questions[state.stepQuiz]),
  currentValue: computed(state => state.answers[state.stepQuiz]),
  setStep: action((state, payload) => {
    state.stepQuiz = payload
  }),
  setShowResults: action((state, payload) => {
    state.showResults = payload
  }),
  setAnswers: action((state, payload) => {
    state.answers = payload
  }),
  setScore: action((state, payload) => {
    state.score = payload
  }),
  setCoupon: action((state, payload) => {
    state.coupon = payload
  }),
  answerQuestion: thunk(async (actions, payload, { getState }) => {
    const { setAnswers } = actions
    const { stepQuiz, answers } = getState()
    const newAnswers = Array.from(answers)
    newAnswers[stepQuiz] = payload
    setAnswers(newAnswers)
  }),
  nextStep: thunk(async (actions, payload, { getState }) => {
    const { stepQuiz, questions } = getState()
    if (questions.length !== stepQuiz + 1) {
      actions.setStep(stepQuiz + 1)
    }
  }),
  submit: thunk(
    async (
      actions,
      payload,
      { getStoreActions, getState, getStoreState },
    ) => {
      const {
        score,
        answers,
        server: {
          endpoint: { [getEnvironment()]: endpoint },
          errors,
        },
      } = getState()
      const { id, secret } = getStoreState().form
      const {
        form: { setOpenModal },
        steps: { nextStep, prevStep },
      } = getStoreActions()
      try {
        if (id === null || secret === null)
          throw new Error('id and secret is required')
        console.log('info to HUB', `score: ${score}`, answers)
        const { filledFields } = getStoreState().form

        // GTM event
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'analyticsEvent',
          eventData: {
            category:
              window.location.pathname + window.location.search,
            action: 'finish_poll',
            label:
              typeof filledFields.newsletter !== 'undefined'
                ? 'yes'
                : 'no',
          },
        })
        // end GTM event

        const { data } = await axios.put(`${endpoint}/${id}`, {
          secret,
          result: {
            responses: answers,
          },
        })
        if (data.success) {
          actions.setCoupon(data.coupon)
          const scoreArray = []
          answers.flat().forEach(item => {
            if (item.match(/[ap]\d/)) {
              scoreArray.push(item)
            }
          })
          const scoreResult = scoreArray.join('')
          actions.setScore(scoreResult)
          actions.setShowResults(true)
          setOpenModal(false)
          nextStep()
        }
        throw new Error(
          `response of put was incorrect: ${data.success}`,
        )
      } catch (error) {
        if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.code === 'alreadyUsed'
        ) {
          actions.setValidationErrors(errors.alreadyUsed.validation)
          actions.setGeneralError(errors.alreadyUsed.message)
          prevStep()
        } else if (error.response && error.response.status === 422) {
          actions.setGeneralError(errors.validation.message)
          prevStep()
        } else if (error.entityTooLarge) {
          actions.setValidationErrors(error.validation)
        } else {
          actions.setShowResults(true)
          setOpenModal(false)
        }
        prevStep()
      }
    },
  ),
}
